import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import { SortOn } from '../../../../containers/ProposalStatsPage/reducer';
import { sort } from '../../../../containers/ProposalStatsPage/actions';
import { StyledButton } from './styles';
import Utils from '../../../../utils';

interface ButtonSortProps {
	field: SortOn;
	label: string;
	sortOn: SortOn;
	isAscending: boolean;
	isDisabled: boolean;
	isDefaultDesc?: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonSort = ({
	field,
	label,
	sortOn,
	isAscending,
	isDisabled,
	isDefaultDesc,
	dispatch,
}: ButtonSortProps) => {
	const handleClick = () => {
		dispatch(sort({
			sortOn: field,
			ascending: field === sortOn ? !isAscending : !isDefaultDesc,
		}));
	};

	return (
		<StyledButton
			type="button"
			disabled={isDisabled}
			isActive={field === sortOn}
			isAscending={field === sortOn ? isAscending : false}
			onClick={handleClick}
		>
			<Translate value={label} />
			{!isDisabled && Utils.getSvgIcon('iconset_triangle-1')}
		</StyledButton>
	);
};

export default ButtonSort;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/ButtonSort/index.tsx